import React from 'react'
 import useSEO from "./useSEO";
const Tallyaccounting = () => {

  useSEO({ 
  title: "Tally Accounting Software | GST Billing & Financial Management",
  description: "Simplify accounting, GST compliance, and financial reporting with Tally Accounting Software. Trusted by businesses for bookkeeping, payroll, and inventory management.",
  keywords: "Tally accounting software, GST billing software, Tally ERP, Tally bookkeeping, Tally payroll management, Tally GST compliance, financial reporting software, inventory and accounts software",
  ogTitle: "Tally Accounting Software - Complete Business Solution",
  ogDescription: "Manage accounts, GST, payroll, and inventory with ease using Tally Accounting Software.",
  ogImage: "img/tally-accounting.png",
  twitterTitle: "Tally Accounting Software - Complete Business Solution",
  twitterDescription: "Streamline accounting, GST compliance, and reporting with Tally Accounting Software.",
  twitterImage: "img/tally-accounting.png"
});

  return (
    <div>

      <>
  <section className="pt-lg-8 pt-xl-9">
    <div className="container position-relative pt-4 pt-lg-0">
      <div className="row align-items-center">
        {/* Title */}
        <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
          <h1 className="mb-4"> Tally Accounting Software</h1>
          <p className="mb-4">
            {" "}
            Tally Accounting Software is one of the most popular and reliable
            accounting systems used by businesses across India and globally.
            Known for its simplicity, flexibility, and power, Tally helps manage
            day-to-day accounting tasks, taxation, payroll, inventory, and more
            — all from a single platform.
          </p>
        </div>
        {/* Image */}
        <div className="col-md-5 ms-auto">
          <img src="img/tally-accounting.png" alt="Tally Accounting Software" />
        </div>
      </div>
    </div>
  </section>
  <section className="overflow-hidden pb-0">
    <div className="container">
      <div className="row align-items-center">
        {/* Image */}
        <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
          {/* Image */}
          <div className="pe-lg-6 pe-xl-8">
            <img
              src="img/tally-accounting1.png"
              alt="Tally Accounting Software"
            />
          </div>
          {/* Decoration */}
        </div>
        {/* Content */}
        <div className="col-lg-6 ms-auto">
          {/* Title and content */}
          <h2 className="mb-lg-4"> Key Features:</h2>
          <hr className="my-4 my-lg-5" /> {/* Divider */}
          {/* List */}
          <div className="row">
            <div className="col-sm-12">
              <ul className="list-group list-group-borderless">
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Comprehensive Accounting: </b>
                </li>
                <p>
                  {" "}
                  Manage general ledger, journal entries, credit/debit notes,
                  accounts receivable/payable, and more with ease.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>GST Compliance: </b>
                </li>
                <p>
                  {" "}
                  Fully equipped for GST billing, return filing, and
                  reconciliation, ensuring you stay compliant at all times.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Inventory Management: </b>
                </li>
                <p>
                  {" "}
                  Track stock movement, batches, expiry, and valuations in real
                  time.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Payroll &amp; HR Management:</b>
                </li>
                <p>
                  Handle employee records, payroll processing, statutory
                  deductions (EPF, ESI), and salary slips.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Banking Integration:</b>
                </li>
                <p>
                  Automate cheque printing, bank reconciliation, and digital
                  payments for smoother transactions.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Customizable Reports: </b>
                </li>
                <p>
                  {" "}
                  Generate insightful reports like Balance Sheets, P&amp;L
                  Statements, Cash Flow, and MIS reports.
                </p>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

      
    </div>
  )
}

export default Tallyaccounting
